import { jsx as o } from "react/jsx-runtime";
import { IconWrapper as r } from "../IconWrapper.js";
const t = ({ className: e, size: l }) => o(r, { className: e, size: l, children: o("svg", { display: "block", fill: "currentColor", width: "100%", height: "100%", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48", children: o("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 24.2614C4 22.5041 5.43269 21.0796 7.2 21.0796H40.8C42.5673 21.0796 44 22.5041 44 24.2614C44 26.0187 42.5673 27.4432 40.8 27.4432H7.2C5.43269 27.4432 4 26.0187 4 24.2614Z" }) }) });
export {
  t as IconMinus
};
